let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ijD3w")).then(() => parcelRequire('9Muer'));